import type { User } from 'types/user';

const InfoRow = ({ label, value }: { label: string; value?: string }) => (
    <div className="flex items-start py-3 border-b border-gray-100 dark:border-gray-700 last:border-0">
        <span className="w-40 shrink-0 text-sm text-gray-500 dark:text-gray-400">{label}</span>
        <span className="text-sm font-medium">{value || '-'}</span>
    </div>
);

const InfoTab = ({ user }: { user: User }) => (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 pb-6 px-6">
        <div>
            <p className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">Thông tin cá nhân</p>
            <InfoRow label="Họ và tên" value={user.firstName || user.lastName ? `${user.firstName} ${user.lastName}`.trim() : user.name} />
            <InfoRow label="Email" value={user.email} />
            <InfoRow label="Điện thoại" value={user.phonenumber} />
            <InfoRow label="Giới tính" value={user.gender} />
            <InfoRow label="Ngày sinh" value={user.dateOfBirth} />
        </div>
        <div>
            <p className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">Tài khoản & Địa chỉ</p>
            <InfoRow label="Quốc gia" value={user.country} />
            <InfoRow label="Thành phố" value={user.city} />
            <InfoRow label="Địa chỉ" value={user.address} />
            <InfoRow label="Ngày tạo" value={user.createAt} />
            <InfoRow label="Đăng nhập cuối" value={user.lastLogin} />
        </div>
    </div>
);

export default InfoTab;
